export default "__VITE_ASSET__DYG6IdpD__"